import { createFeatureSelector, createSelector } from "@ngrx/store";

import { shopLocationsFeatureKey } from "./shop-locations.reducer";
import {
    SHOP_LOCATIONS_CITY_MODE,
    SHOP_LOCATIONS_COUNTRY_MODE,
    SHOP_LOCATIONS_DEFAULT_MODE,
    ShopLocationsState,
} from "./shop-locations.state";

export const selectShopLocatorState = createFeatureSelector<ShopLocationsState>(
    shopLocationsFeatureKey,
);

export const selectContinents = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => state.continents,
);

export const selectCountries = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => state.countries,
);

export const selectCities = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => state.cities,
);

export const selectHasCountries = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) =>
        state.countries && state.countries.length > 0,
);

export const selectHasCities = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => state.cities && state.cities.length > 0,
);

export const selectMode = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => state.pageMode,
);

export const selectCurrentCountry = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => {
        if (
            state.pageMode === SHOP_LOCATIONS_COUNTRY_MODE ||
            state.pageMode === SHOP_LOCATIONS_DEFAULT_MODE ||
            state.pageMode === SHOP_LOCATIONS_CITY_MODE
        ) {
            return state.currentCountry;
        }
        return undefined;
    },
);

export const selectCurrentCity = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => {
        if (state.pageMode === SHOP_LOCATIONS_CITY_MODE) {
            return state.currentCity;
        }
        return undefined;
    },
);

export const selectCurrentLocation = createSelector(
    selectShopLocatorState,
    (state: ShopLocationsState) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {
            cities,
            countries,
            continents,
            ...stateWithoutCountriesAndCities
        } = state;
        return stateWithoutCountriesAndCities;
    },
);
